<!-- 党建专题 -->
<template>
<div class='cm_part_special_container' >
  <div class="cm_part_special_heading" :style="{background:'url('+imgUrl+') center no-repeat'}">
<!--    <img :src="imgUrl">-->
<!--    <a href="">MORE+</a>-->
  </div>
  <ul class="cm_part_special_content" v-loading="loading" style="min-height:280px">
    <li v-for="(item) in dataList" :key="item.NEWS_ID" @click="toDetail(item.NEWS_ID,data)">
      <h3>{{item.TITLE}}</h3>
      <span>{{cutDate(item.PUBLISH_DATE)}}</span>
    </li>
  </ul>
</div>
</template>

<script>


export default {
components: {},
props:["data","indexUrl","parentAlias"],
data() {
//这里存放数据
return {
  dataList:[],
  dataEmpty:true,
  imgUrl: "",
  webConfigue: JSON.parse(window.localStorage.getItem("webConfigue")),
  localUrl:window.SITE_CONFIG.baseUrl,
  loading:true
};
},
//监听属性 类似于data概念
computed: {
  cutDate:function(date){
      return (date)=>date.substring(5)
    }
},
//监控data中的数据变化
watch: {},
//方法集合
methods: {
  hasAlias: function (arr, alias1) {
    let alias = ""
    if (alias1 != "" && alias1 != undefined && alias1 != null) {
      alias = alias1.channelId
      for (let i = 0; i < arr.length; i++) {
        if (
                arr[i][this.parentAlias] != "" &&
                arr[i][this.parentAlias] != undefined &&
                arr[i][this.parentAlias] != null
        ) {
          for (let j = 0; j < arr[i][this.parentAlias].length; j++) {
            if (arr[i][this.parentAlias][j].TEMPLATE_ID == alias) {
              if(arr[i][this.parentAlias][j].FILE!=""&&arr[i][this.parentAlias][j].FILE!=undefined&&arr[i][this.parentAlias][j].FILE!=null){
                this.imgUrl = this.localUrl + arr[i][this.parentAlias][j].FILE[0].PATH
                // console.log(this.imgUrl)
              }else{
                this.imgUrl = this.indexUrl
              }
              // return true;
            }
          }
        }
      }
      return false
    }else{
      return true;
    }},
  httpPost() {
      this.loading = true
      this.$http({
        url: this.$http.adornUrl(this.$store.state.comUrl),
        method: 'post',
        data: this.data
      }).then(({ data }) => {
        if(data.data!=''&&data.data!=undefined&&data.data!=null){
          if(data.data.pdList!=''&&data.data.pdList!=undefined&&data.data.pdList!=null&&data.data.pdList.length!=0){
            this.dataList = data.data.pdList
            this.loading = false
            // this.dataEmpty = false
            // this.$emit('dataChildEmpty', this.dataEmpty)
          }else{
            // this.dataEmpty = true
            // this.$emit('dataChildEmpty', this.dataEmpty)
          }

        }

      });
    },
    toDetail(ID,data){
      this.$router.push({path:'/detail/'+ID,query: {parentData:JSON.stringify(data)}})
    },

},
//生命周期 - 创建完成（可以访问当前this实例）
created() {

},
//生命周期 - 挂载完成（可以访问DOM元素）
mounted() {
  this.httpPost()
  this.hasAlias(this.webConfigue,this.data)
},

}
</script>
<style scoped>
.cm_part_special_container{
  width: 370px;
  height: 410px;
  background: #FFFFFF;
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.09);
  margin-top: 20px;
}
.cm_part_special_heading{
  width: 100%;
  height: 152px;
  background: linear-gradient(315deg, #B20808 0%, #DC1212 100%);
}
.cm_part_special_heading>a{
  font-size: 14px;
  font-weight: 500;
  color: #FFFFFF;
  float: right;
  margin-right: 10px;
  margin-top: 30px;
}
.cm_part_special_content{
  padding:0 20px;
  list-style-type: circle;
}
.cm_part_special_content>li{
  display:flex;
  justify-content: space-between;
  padding: 10px 0;
  cursor: pointer;
}
.cm_part_special_content>li:hover>h3{
  color: #CA0E0E;
}
.cm_part_special_content>li>h3:before {
  content: "";
  width: 4px;
  height: 4px;
  display: inline-block;
  border-radius: 50%;
  background: #D41010;
  vertical-align: middle;
  margin-right: 6px;
}
.cm_part_special_content>li>h3{
  width: 89%;
  font-size: 16px;
  font-weight: 400;
  color: #000000;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.cm_part_special_content>li>span{
  width:60px;
  font-size: 16px;
  font-weight: 400;
  color: #BFBFBF;
}
</style>
